export const notificationConstant = {tradingQueue: 'tradingQueue', p2p: 'p2p', avn: 'avn'}
